import { render, staticRenderFns } from "./UITitle.vue?vue&type=template&id=1d310d24&scoped=true"
import script from "./UITitle.vue?vue&type=script&lang=ts"
export * from "./UITitle.vue?vue&type=script&lang=ts"
import style0 from "./UITitle.vue?vue&type=style&index=0&id=1d310d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d310d24",
  null
  
)

export default component.exports